import { profileTh } from "@/module/Profile/locale/ProfileLocaleTh.js";

export const th = {
    default: {
        search: 'ค้นหา',
        confirm: 'ยืนยัน',
        ok: 'OK',
        cancel: 'ยกเลิก',
        close: 'ปิด',
        retry: 'ลองอีกครั้ง',
        btn_coupon: 'คูปองของฉัน',

        error_title: 'ขออภัย',
        no_internet: 'กรุณาลองอีกครั้ง',
        btn_try_again: 'ลองอีกครั้ง',
    },
    header: {
        placeholder: 'ค้นหา'
    },
    profile: profileTh,
    date: {
        days: 'วัน',
        months: 'เดือน',
        years: 'ปี',
        minutes: 'นาที',
        minutes_short: 'น.',
        hours: 'ชั่วโมง',
        hours_short: 'ช.ม.',
        date_flase: 'กรุณาระบุวันเกิด',
        month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }],
        months_all: 'เดือนทั้งหมด',
        years_all: 'ปีทั้งหมด'
    },
    confirm_redeem: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        group: {
            '1': {
                headline: 'คุณต้องการรับสิทธิ์ให้ตัวเอง<br/>หรือโอนสิทธิ์ให้ผู้อื่น',
                message: 'กรุณากรอกข้อมูลของผู้รับสิทธิ์ในขั้นตอนถัดไป เพื่อยืนยันรับสิทธิ์์',
                btnPrimary: 'รับสิทธิ์เอง',
                btnSecondary: 'โอนสิทธิ์ให้ผู้อื่น'
            },
            '2': {
                headline: 'คุณต้องการรับสิทธิ์ให้ตัวเอง<br/>หรือโอนสิทธิ์ให้ผู้อื่น',
                message: 'กรุณากรอกข้อมูลของผู้รับสิทธิ์ในขั้นตอนถัดไป เพื่อยืนยันรับสิทธิ์์',
                btnPrimary: 'รับสิทธิ์เอง',
                btnSecondary: 'โอนสิทธิ์ให้ผู้อื่น'
            },
            '3': {
                headline: 'คุณต้องการรับสิทธิ์ให้ตัวเอง<br/>หรือโอนสิทธิ์ให้ผู้อื่น',
                message: 'กรุณากรอกข้อมูลของผู้รับสิทธิ์ในขั้นตอนถัดไป เพื่อยืนยันรับสิทธิ์์',
                btnPrimary: 'รับสิทธิ์เอง',
                btnSecondary: 'โอนสิทธิ์ให้ผู้อื่น'
            },
            '4': {
                headline: 'ยืนยันการสมัคร<br/>{0}',
                viz_card: 'VIZ Card',
                grayson_card: 'Graysorn Card',
                message: '',//"You'll be taken to fill in your info,<br/>in the next screen.",
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            },
            '5':{
                headline: 'ยืนยันรับสิทธิ์', //'ยืนยันรับสิทธิ์์',
                headline_timer: 'รหัสนี้มีอายุ {0} <br/>หลังยืนยัน กรุณาใช้ทันที',
                message: '',//'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            },
            '6': {
                headline: 'ยืนยันรับสิทธิ์', //'ยืนยันรับสิทธิ์์',
                headline_timer: 'รหัสนี้มีอายุ {0} <br/>หลังยืนยัน กรุณาใช้ทันที',
                message: '', //'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            },
            '8': {
                headline: 'ยืนยันรับสิทธิ์',
                // viz_card: 'VIZ Card',
                // grayson_card: 'Graysorn Card',
                message: "",//"You'll be taken to fill in your info,<br/>in the next screen.",
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            },
            '9': {
                headline: 'ยืนยันรับสิทธิ์',
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            },
            'default': {
                headline: 'ยืนยันรับสิทธิ์', //'ยืนยันรับสิทธิ์์',
                headline_timer: 'รหัสนี้มีอายุ {0} <br/>หลังยืนยัน กรุณาใช้ทันที',
                message: '',//'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            },
            'ambassador': {
                message: 'ยืนยันรับสิทธิ์',
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            },
            'draw': {
                headline: 'ยืนยันการลุ้นรางวัล', //'ยืนยันรับสิทธิ์์',
                headline_timer: 'ยืนยันการลุ้นรางวัล',
                message: '',//'Would you like to redeem this reward?',
                message_timer: '',
                btnPrimary: 'ยืนยัน',
                btnSecondary: 'ยกเลิก'
            }
        },

        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันรับสิทธิ์์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันรับสิทธิ์์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
    },
    redeem_button: {
        default: 'รับสิทธิ์',
        draw: 'ลุ้นรางวัล',
        isLoading: 'กำลังดำเนินการ',
        none: '',
        soldOut: 'มีผู้ใช้สิทธิ์ครบตามจำนวนที่กำหนดแล้ว',
        soldOutBuy: 'มีผู้ใช้สิทธิ์ครบตามจำนวนที่กำหนดแล้ว',
        maxPerPerson: 'คุณเคยรับสิทธิ์นี้แล้ว',
        redeemCoolDown: 'คุณเคยรับสิทธิ์นี้แล้ว',
        nextDate: 'รับสิทธิครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'การรับสิทธิ์นี้จำเป็นต้องทำตามเงื่อนไขของแคมเปญ กรุณาอ่านรายละเอียดด้านบน',
        campaignExpired: 'สิทธิ์นี้หมดอายุแล้ว',
        campaignExpiredBuy: 'สิทธิ์นี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนไม่พอในการแลกสิทธิ์นี้',
        notEnoughCredit: 'เครดิตไม่พอในการแลกสิทธิ์นี้',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้',
        notPublish: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        exceedQuota: 'ใช้สิทธิครบแล้ว',
        notAmbassador: 'การรับสิทธิ์นี้จำเป็นต้องทำตามเงื่อนไขของแคมเปญ กรุณาอ่านรายละเอียดด้านบน',
        userPrestige: 'ประเภทสมาชิกของคุณไม่ได้เข้าร่วมกับสิทธิ์นี้',
        unableProceed: 'ไม่สามารถดำเนินการได้',
        notAvailableTier: 'สิทธิ์นี้สำหรับลูกค้าเอไอเอ เพรสทีจเท่านั้น สามารถดูข้อมูลได้ที่ปุ่มด้านล่าง',
        explor: 'ดูข้อมูลเอไอเอ เพรสทีจ',
        remaining: 'สิทธิ์คงเหลือ',
        use: 'ใช้',
        credits: 'เครดิต',
        // WI #878678 mapping text key: no_level_block (Proposed text, pending confirm Q2)
        noLevelBlock: 'ไม่สามารถ Redeem ได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง'
    },
    purchase: {
        show_code: 'กดเพื่อดูรหัส',
        code_expired: 'รหัสหมดอายุ',

        redeem_date: 'วันที่รับสิทธิ : {0}',
        expire_date: 'หมดอายุ : {0}',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
        shipped: 'สินค้าได้ถูกจัดส่งเรียบร้อยแล้ว',
        parcel_no: 'พัสดุเลขที่',

        not_draw: 'ยังไม่ประกาศผล',
        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win: 'ขออภัย คุณไม่ได้รับของรางวัลนี้ กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',

        status_available: 'แสดงรหัส',
        status_cancelled: 'ยกเลิก',
        status_expired: 'หมดอายุ',
        status_used: 'ใช้แล้ว',
        status_refill: 'ยังไม่สมบูรณ์กรุณากรอกข้อมูลเพิ่มเติม',
        status_transfered: 'โอนสิทธิ',
        status_group_8: 'ยังไม่สมบูรณ์กรุณากรอกข้อมูลเพิ่มเติม',
        status_min_match: 'ระดับสถานะของท่านมีการเปลี่ยนแปลง กรุณาติดต่อ AIA Prestige Line<br/>โทร. 02 353 8900'
    },
    serial: {
        refill_line_1: 'การสมัครสมาชิกของท่านยังไม่สมบูรณ์',
        refill_line_2: 'กรุณากรอกข้อมูลส่วนตัวของท่านและกด<br/>"ส่งข้อมูล"',
        refill_btn: 'กรอกข้อมูลเพิ่มเติม',
        refill_group_8: 'การรับสิทธิของท่านยังไม่สมบูรณ์ กรุณากรอกข้อมูลส่วนตัวของท่านและกด "ส่งข้อมูล"',

        close_btn: 'ปิด',
        show_code_at_shop: 'แสดง{0}กับพนักงานที่หน้าร้าน',
        group_one_show_code: 'กรุณาแสดงรหัสจากเมนู คูปองของฉัน แก่เจ้าหน้าที่<br/>ณ วันที่เข้ารับบริการตามที่ท่านนัดหมาย',
        group_five_show_code: 'กรุณาแสดงรหัสแก่เจ้าหน้าที่ ณ จุดให้บริการ /<br/>ตรวจสอบข้อมูลได้ที่คูปองของฉัน ',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'รหัส',

        copy_code: 'คัดลอกรหัส',
        copy_success_title: 'คัดลอกรหัสสำเร็จ',

        expire_in: 'หมดอายุภายใน : ',
        code_expired: 'รหัสหมดอายุ',
        day: 'วัน',

        redeem_on: 'วันที่รับสิทธิ : {0}',

        group_one_redeem_on: 'วันที่ยืนยันรับสิทธิ์ : {0}',
        group_five_redeem_on: 'วันที่รับสิทธิ : {0}',

        footer_close: 'ถัดไป',
        footer_cancel_redemption: 'ยกเลิกการรับ/โอนสิทธิ',
        footer_cancel_group_9: 'ยกเลิกการรับสิทธิ',

        cancel: 'ยกเลิก',
        expired: 'หมดอายุ',
        used: 'ใช้สิทธิแล้ว',
        transfer: 'โอนสิทธิ',
        min_match: 'ระดับสถานะของท่านมีการเปลี่ยนแปลง กรุณาติดต่อ AIA Prestige Line<br/>โทร. 02 353 8900',

        cancel_title: 'ยืนยันการยกเลิกสิทธิ',
        cancel_msg: '',
        cancel_no: 'ยกเลิก',
        cancel_yes: 'ตกลง',

        cancel_success_title: 'กรุณากรอกข้อมูลเพิ่มเติม<br/>ของผู้รับสิทธิ เพื่อแจ้งยืนยัน<br/>การยกเลิกสิทธิทาง SMS / อีเมล',
        cancel_success_msg: "",
        cancel_ok: 'ตกลง',
        error_msg: 'การยกเลิกและคืนสิทธิ<br/>ต้องไม่น้อยกว่า 7 วัน<br/>นับจากวันสิ้นสุดการจอง',
        redeem_success: "รับสิทธิ์สำเร็จ",
        redeem_expire: "รหัสหมดอายุ ไม่สามารถรับสิทธิ์ได้",
        btn_privilege: "กลับหน้าสิทธิพิเศษ",
        btn_coupon: "คูปองของฉัน"
    },
    gift_serial: {
        show_code_at_shop: 'แสดง{0}กับพนักงานที่หน้าร้าน',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'รหัส',

        copy_code: 'คัดลอกรหัส',
        copy_success_title: 'คัดลอกรหัสสำเร็จ',

        expire_in: 'หมดอายุภายใน : ',
        day: 'วัน',

        redeem_on: 'วันที่รับสิทธิ : {0}',

        cancel: 'ยกเลิก',
        expired: 'หมดอายุ',
    },
    draw_delivery: {
        title: 'ขอบคุณที่ร่วมสนุกกับเรา',
        msg: 'กรุณาติดตามประกาศผลรางวัลเร็วๆนี้',
        announcement_btn: 'ประกาศผลรางวัล'
    },
    redeem_success: {
        group: {
            '1': {
                headline: 'กรุณากรอกข้อมูลเพิ่มเติม<br/>ของผู้รับสิทธิ เพื่อแจ้งยืนยัน<br/>การรับสิทธิทาง SMS / อีเมล',
                message: "",
                btnPrimary: 'ตกลง',
                btnSecondary: 'NO'
            },
            '2': {
                headline: 'กรุณากรอกข้อมูลเพิ่มเติม<br/>ของผู้รับสิทธิ เพื่อแจ้งยืนยัน<br/>การรับสิทธิทาง SMS / อีเมล',
                message: "",
                btnPrimary: 'ตกลง',
                btnSecondary: 'NO'
            },
            '3': {
                headline: 'กรุณากรอกข้อมูลเพิ่มเติม<br/>ของผู้รับสิทธิ เพื่อแจ้งยืนยัน<br/>การรับสิทธิทาง SMS / อีเมล',
                message: "",
                btnPrimary: 'ตกลง',
                btnSecondary: 'NO'
            },
            '4': {
                headline: 'Successfully Redeemed Reward',
                message: "You'll be forward to the next screen",
                btnPrimary: 'OK',
                btnSecondary: 'NO'
            },
            '5':{
                headline: 'การรับสิทธิสำเร็จ',
                message: "",
                btnPrimary: 'คูปองของฉัน',
                btnSecondary: 'ปิด'
            },
            '6': {
                headline: 'การรับสิทธิสำเร็จ',
                message: "",
                btnPrimary: 'คูปองของฉัน',
                btnSecondary: 'ปิด'
            },
            '9': {
                headline: 'กรุณากรอกข้อมูลเพิ่มเติม<br/>ของผู้รับสิทธิ เพื่อแจ้งยืนยัน<br/>การรับสิทธิทาง SMS / อีเมล',
                message: "",
                btnPrimary: 'ตกลง',
                btnSecondary: 'NO'
            },
            'default': {
                headline: 'การรับสิทธิสำเร็จ',
                message: "",
                btnPrimary: 'คูปองของฉัน',
                btnSecondary: 'ปิด'
            },
            'ambassador': {
                headline: 'การรับสิทธิสำเร็จ',
                message: "",
                btnPrimary: 'คูปองของฉัน',
                btnSecondary: 'ปิด'
            },
        }
    },
    shipping: {
        headline: 'ที่อยู่จัดส่ง',

        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'เขต/ตำบล',
            placeholder: 'กรุณาเลือกเขต/ตำบล',
            required: 'กรุณาเลือกเขต/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'แขวง/อำเภอ',
            placeholder: 'กรุณาเลือกแขวง/อำเภอ',
            required: 'กรุณาเลือกแขวง/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        terms: "Terms And Conditions",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
    },
    campaign: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
    },
    detail: {
        mass_headline: 'สิทธิพิเศษ',
        prestige_headline: 'เอกสิทธิ์',
        expire_date: 'หมดอายุ : {0}',
        reward_detail: 'รายละเอียดของรางวัล',

        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',
        duration: 'ระยะเวลา',

        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        available_date: 'แลกได้วันที่',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },

        quota_not_available: 'ไม่พบข้อมูลโควต้า',

        max_group_4: 'คุณยังลงทะเบียนไม่สำเร็จ',
        msg_max_group_4: 'กรุณาเลือกคูปองของฉันเพื่อดำเนินการต่อ',
        err_409_maximum_quota: 'ขออภัย สิทธิคงเหลือของท่าน<br/>ไม่เพียงพอสำหรับรับเอกสิทธิ์นี้',

        send_to_friend_title: 'กรุณากรอกข้อมูลเพิ่มเติม<br/>ของผู้รับโอนสิทธิ เพื่อแจ้งยืนยัน<br/>การรับสิทธิทาง SMS / อีเมล',//'Confirm to send reward to your friend',
        send_to_friend_msg: "",
    },
    history: {
        date_select_placeholder: 'ทั้งหมด',
        burn_tab: 'คูปองที่ยังไม่ได้ใช้',
        used_tab: 'คูปองที่ใช้แล้ว',

        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',

        parcel_number: 'เลขพัสดุ : ',

        empty_list: 'ไม่พบข้อมูล'
    },
    home: {
        ambassador: 'แอมบาสเดอร์',
        tier_lvl: {
            'c': 'ระดับ คลาสสิค',
            's': 'ระดับ ซิลเวอร์',
            'g': 'ระดับ โกลด์',
            'p': 'ระดับ แพลทินัม'
        },
        see_all: 'ดูทั้งหมด'
    },
    reward: {
        expire_date: 'หมดอายุ : {0}',
        quota: 'สิทธิคงเหลือ : {0} สิทธิสูงสุดต่อปี',
        quota_month: 'สิทธิคงเหลือ : {0} สิทธิสูงสุดต่อเดือน</br>(รวมทุกพันธมิตร)',
        quota_year: 'สิทธิคงเหลือ : {0} สิทธิสูงสุดต่อปี</br>(รวมทุกพันธมิตร)',
        quota_year_not_allies: 'สิทธิคงเหลือ : {0} สิทธิสูงสุดต่อปี',
        quota_season: 'สิทธิคงเหลือ : {0}  สิทธิสูงสุดต่อฤดูกาล (รวมทุกแมตซ์การแข่งขัน)',
        quota_life_time: 'สิทธิคงเหลือ : {0} สิทธิ ตลอดการเป็นสมาชิกโครงการ',
        quota_per_hour: 'สิทธิคงเหลือ : {0} ชั่วโมง',
        no_data: 'ไม่พบข้อมูล',

        search_history: 'ประวัติการค้นหา',
        search_result: 'ผลการค้นหา : ',

        start_date_lbl: 'เริ่มต้น {0}',
        end_date_lbl: 'สิ้นสุด '
    },
    about_us: {
        mass: {
            tel: 'ติดต่อเอไอเอ คอลเซ็นเตอร์',
            tel_content: '1581',
            tel_number: '1581',
            term: 'ข้อกำหนดการใช้สิทธิพิเศษของเอไอเอ',
            faq: 'คำถามที่พบบ่อย'
        },
        prestige: {
            tel: 'ติดต่อศูนย์บริการลูกค้าเอไอเอ เพรสทีจ',
            tel_content: '0 2353 8900',
            tel_number: '0-2353-8900',
            open_web: 'เว็บไซต์โครงการเอไอเอ เพรสทีจ คลับ',
            open_web_content: 'aia.co.th/prestigeclub',
            email: 'อีเมลโครงการเอไอเอ เพรสทีจ คลับ',
            email_content: 'th.prestigeclub@aia.com',
            email_address: 'th.prestigeclub@aia.com',
            term: 'ข้อกำหนดการถือครองสิทธิ และยกระดับสถานะในโครงการเอไอเอ เพรสทีจ คลับ',
            privilege: 'ข้อกำหนดการใช้เอกสิทธิ์ภายใต้โครงการ เอไอเอ<br/>เพรสทีจ คลับ',
            faq: 'คำถามที่พบบ่อย'
        },
        open_web_address: 'https://www.aia.co.th/prestigeclub',
    },
    faq: {
        headline: 'คำถามที่พบบ่อย',
        mass_question: [
            {
                q: 'ตรวจสอบประวัติการรับสิทธิ ได้อย่างไร',
                a: 'สามารถตรวจสอบรายละเอียดได้จากเมนู คูปองของฉัน',
            },
            {
                q: 'หากมีการกดรับสิทธิไว้แล้วแต่ยังไม่ได้ใช้ รหัสนั้นจะถูกเก็บไว้ที่ใด',
                a: 'เอกสิทธิ์ที่มีการกดรับสิทธิไว้แล้ว จะถูกบันทึกอยู่ในเมนู คูปองของฉัน ทั้งหมด โดยแบ่งเป็นคูปองที่ยังไม่ได้ใช้ และ คูปองที่ใช้ไปแล้ว / หมดอายุ',
            },
            {
                q: 'หากต้องการรับสิทธิเพิ่ม หรือใช้สิทธิ 2 ครั้ง พร้อมกัน สามารถทำได้อย่างไร',
                a: 'หากท่านยังมีสิทธิคงเหลือ ท่านสามารถกดรับสิทธิเพิ่มได้ทันที โดยปฎิบัติตามวิธีรับสิทธิปกติ และท่านสามารถตรวจสอบคูปองที่กดรับสิทธิแล้วในเมนู คูปองของฉัน',
            },
            {
                q: 'หากต้องการยกเลิกเอกสิทธิ์ที่กดรับไปแล้ว สามารถทำได้หรือไม่',
                a: 'ไม่สามารถทำได้เนื่องจาก สิทธิพิเศษมีการกำหนดระยะเวลาใช้หลังการกดรับสิทธิ จึงไม่สามารถยกเลิก หรือชดเชยสิทธิได้ หากไม่ใช้สิทธิตามระยะเวลาที่กำหนด',
            },
            {
                q: 'ติดต่อสอบถามรายละเอียดผลิตภัณฑ์ หรือบริการต่างๆของเอไอเอ ได้จากที่ใด',
                a: '1. เว็บไซต์ : <a href="https://www.aia.co.th">www.aia.co.th</a><br/>2. เอไอเอ คอลเซ็นเตอร์ โทร. <a href="tel:1581">1581</a><br/>3. ตัวแทนเอไอเอ',
            },
            {
                q: 'หากเกิดปัญหาในการรับสิทธิพิเศษ หรือการใช้แอปพลิเคชัน ต้องทำอย่างไร',
                a: 'ติดต่อสอบถามได้ที่ เอไอเอ คอลเซ็นเตอร์ โทร. <a href="tel:1581">1581</a>',
            }
        ],
        prestige_question: [
            {
                q: 'ตรวจสอบระดับสถานะ เอกสิทธิ์และจำนวนสิทธิที่ได้รับได้อย่างไร',
                a: 'สามารถตรวจสอบรายละเอียดได้จากเมนู ข้อมูลสมาชิก',
            },
            {
                q: 'ตรวจสอบประวัติการรับสิทธิ ได้อย่างไร',
                a: 'สามารถตรวจสอบรายละเอียดได้จากเมนู คูปองของฉัน',
            },
            {
                q: 'หากมีการกดรับสิทธิไว้แล้วแต่ยังไม่ได้ใช้ รหัสนั้นจะถูกเก็บไว้ที่ใด',
                a: 'เอกสิทธิ์ที่มีการกดรับสิทธิไว้แล้ว จะถูกบันทึกอยู่ในเมนู คูปองของฉัน ทั้งหมด โดยแบ่งเป็นคูปองที่ยังไม่ได้ใช้ และ คูปองที่ใช้ไปแล้ว / หมดอายุ',
            },
            {
                q: 'หากต้องการรับสิทธิเพิ่ม หรือใช้สิทธิ 2 ครั้ง พร้อมกัน สามารถทำได้อย่างไร',
                a: 'หากท่านยังมีสิทธิคงเหลือ ท่านสามารถกดรับสิทธิเพิ่มได้ทันที โดยปฎิบัติตามวิธีรับสิทธิปกติ และท่านสามารถตรวจสอบคูปองที่กดรับสิทธิแล้วในเมนู คูปองของฉัน',
            },
            {
                q: 'เอกสิทธิ์ประเภทใดจะต้องกดรับสิทธิล่วงหน้า และต้องนัดหมายก่อนวันรับบริการ',
                a: 'บริการบัตรตรวจสุขภาพประจำปี บริการรถลีมูซีน บริการรถกอล์ฟและด่านตรวจคนเข้าเมืองด่วนพิเศษ และการเข้าร่วมกิจกรรมต่างๆ',
            },
            {
                q: 'หากต้องการยกเลิกเอกสิทธิ์ที่กดรับไปแล้ว สามารถทำได้หรือไม่ ',
                a: 'เอกสิทธิ์ประเภทที่ต้องทำการกดรับสิทธิล่วงหน้า ได้แก่ บริการบัตรตรวจสุขภาพประจำปี บริการรถลีมูซีน บริการรถกอล์ฟและด่านตรวจคนเข้าเมืองด่วนพิเศษ และการเข้าร่วมกิจกรรมต่างๆ สามารถยกเลิกการรับสิทธิได้ โดยเป็นไปตามเงื่อนไขของแต่ละเอกสิทธิ์ โปรดศึกษาเงื่อนไขการใช้สิทธิ์อย่างละเอียดอีกครั้ง ซึ่งสามารถยกเลิกได้ผ่านเมนู คูปองของฉัน เอกสิทธิ์ที่มีการกำหนดระยะเวลาใช้หลังการกดรับสิทธิ ได้แก่ บัตรชมภาพยนตร์ บริการฟิตเนส บริการห้องรับรอง ณ สนามบิน หรือบริการอื่นๆ จากพันธมิตร จะไม่สามารถยกเลิก หรือชดเชยสิทธิได้ หากไม่ใช้สิทธิตามระยะเวลาที่กำหนด',
            },
            {
                q: 'หากต้องการเปลี่ยนแปลงเบอร์โทร หรืออีเมล ที่ให้ข้อมูล ณ วันกดรับสิทธิ ต้องทำอย่างไร ',
                a: 'กรุณายกเลิกการรับเอกสิทธินั้น โดยเข้าไปที่เมนู คูปองของฉัน และกดรับสิทธิใหม่อีกครั้ง',
            },
            {
                q: 'เอกสิทธิ์บริการตรวจสุขภาพยังสามารถโอนสิทธิให้บุคคลในครอบครัว รับสิทธิแทนได้หรือไม่',
                a: 'เอกสิทธิ์บริการตรวจสุขภาพสามารถโอนสิทธิให้บุคคลในครอบครัวรับสิทธิแทนได้',
            },
            {
                q: 'เอกสิทธิ์และจำนวนเอกสิทธิ์ที่ได้รับของแต่ละสถานะเป็นอย่างไร',
                a: 'ท่านสามารถศึกษารายละเอียดได้ที่ <a href="https://www.aia.co.th/prestigeclub">www.aia.co.th/prestigeclub</a> เลือกหัวข้อ เอกสิทธิ์พิเศษ',
            },
            {
                q: 'หากเกิดปัญหาในการรับเอกสิทธิ์ หรือต้องการตรวจสอบสิทธิของตนเองต้องทำอย่างไร',
                a: 'ติดต่อสอบถามได้ที่ ศูนย์บริการลูกค้าเพรสทีจ โทร <a href="tel:023538900">0 2353 8900</a> ทุกวัน เวลา 8.00 – 20.00 น.',
            },
            {
                q: 'สามารถศึกษารายละเอียดโครงการเอไอเอ เพรสทีจ คลับ ได้จากช่องทางใด',
                a: '1. คู่มือเอกสิทธิ์พิเศษสมาชิกโครงการ<br/>2. เว็บไซต์ : <a href="https://www.aia.co.th/prestigeclub">www.aia.co.th/prestigeclub</a><br/>3. เอไอเอ เพรสทีจ คลับ คอลเซ็นเตอร์ โทร <a href="tel:023538900">0 2353 8900</a> ทุกวัน เวลา 8.00 – 20.00 น.<br/>4. ตัวแทนเอไอเอ',
            }
        ]
    },
    terms: {
        terms_headline: {
            mass: 'ข้อกำหนดการใช้สิทธิพิเศษของเอไอเอ',
            prestige: 'ข้อกำหนดการถือครองสิทธิ การต่ออายุ และยกระดับ<br/>สถานะในโครงการเอไอเอ เพรสทีจ คลับ'
        },
        privilege_headline: 'ข้อกำหนดการใช้เอกสิทธิ์ภายใต้<br/>โครงการเอไอเอ เพรสทีจ คลับ',
    },
    error: {
        error_title: 'ขออภัย',
        error_msg: 'เกิดข้อผิดพลาด กรุณาลองอีกครั้ง',
    }
};
